import { jsxs as pn, jsx as Pe } from "react/jsx-runtime";
import { k as bn } from "./use-theme-xHxAHy0N-C40aLO4N.js";
import { $ as mn } from "./utils-CTvPli9r.js";
import { c as yn, g as En } from "./react-icons.esm-CDi78UIJ.js";
import be, { useState as vn, useCallback as Nn } from "react";
import { Button as Sn } from "./button.js";
import { _ as wn } from "./extends-hS2Bh-Yp.js";
function vt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function _n(e, n) {
  if (e == null) return {};
  var i = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (n.indexOf(o) !== -1) continue;
    i[o] = e[o];
  }
  return i;
}
function xn(e, n) {
  if (e == null) return {};
  var i, o, g = _n(e, n);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(e);
    for (o = 0; o < u.length; o++) i = u[o], n.indexOf(i) === -1 && {}.propertyIsEnumerable.call(e, i) && (g[i] = e[i]);
  }
  return g;
}
function Ze(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, o = Array(n); i < n; i++) o[i] = e[i];
  return o;
}
function On(e) {
  if (Array.isArray(e)) return Ze(e);
}
function Rn(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function An(e, n) {
  if (e) {
    if (typeof e == "string") return Ze(e, n);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Ze(e, n) : void 0;
  }
}
function Tn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mn(e) {
  return On(e) || Rn(e) || An(e) || Tn();
}
function Oe(e) {
  "@babel/helpers - typeof";
  return Oe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Oe(e);
}
function Ln(e, n) {
  if (Oe(e) != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var o = i.call(e, n);
    if (Oe(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function In(e) {
  var n = Ln(e, "string");
  return Oe(n) == "symbol" ? n : n + "";
}
function Nt(e, n, i) {
  return (n = In(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function ft(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, o);
  }
  return i;
}
function _e(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ft(Object(i), !0).forEach(function(o) {
      Nt(e, o, i[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ft(Object(i)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
    });
  }
  return e;
}
function kn(e) {
  var n = e.length;
  if (n === 0 || n === 1) return e;
  if (n === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (n === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (n >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var qe = {};
function Cn(e) {
  if (e.length === 0 || e.length === 1) return e;
  var n = e.join(".");
  return qe[n] || (qe[n] = kn(e)), qe[n];
}
function Pn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 ? arguments[2] : void 0, o = e.filter(function(u) {
    return u !== "token";
  }), g = Cn(o);
  return g.reduce(function(u, I) {
    return _e(_e({}, u), i[I]);
  }, n);
}
function dt(e) {
  return e.join(" ");
}
function jn(e, n) {
  var i = 0;
  return function(o) {
    return i += 1, o.map(function(g, u) {
      return St({
        node: g,
        stylesheet: e,
        useInlineStyles: n,
        key: "code-segment-".concat(i, "-").concat(u)
      });
    });
  };
}
function St(e) {
  var n = e.node, i = e.stylesheet, o = e.style, g = o === void 0 ? {} : o, u = e.useInlineStyles, I = e.key, M = n.properties, O = n.type, U = n.tagName, N = n.value;
  if (O === "text")
    return N;
  if (U) {
    var R = jn(i, u), j;
    if (!u)
      j = _e(_e({}, M), {}, {
        className: dt(M.className)
      });
    else {
      var l = Object.keys(i).reduce(function(p, E) {
        return E.split(".").forEach(function(x) {
          p.includes(x) || p.push(x);
        }), p;
      }, []), W = M.className && M.className.includes("token") ? ["token"] : [], k = M.className && W.concat(M.className.filter(function(p) {
        return !l.includes(p);
      }));
      j = _e(_e({}, M), {}, {
        className: dt(k) || void 0,
        style: Pn(M.className, Object.assign({}, M.style, g), i)
      });
    }
    var y = R(n.children);
    return /* @__PURE__ */ be.createElement(U, wn({
      key: I
    }, j), y);
  }
}
const Dn = function(e, n) {
  var i = e.listLanguages();
  return i.indexOf(n) !== -1;
};
var Bn = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function ht(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(g) {
      return Object.getOwnPropertyDescriptor(e, g).enumerable;
    })), i.push.apply(i, o);
  }
  return i;
}
function fe(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ht(Object(i), !0).forEach(function(o) {
      Nt(e, o, i[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ht(Object(i)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
    });
  }
  return e;
}
var $n = /\n/g;
function Un(e) {
  return e.match($n);
}
function Hn(e) {
  var n = e.lines, i = e.startingLineNumber, o = e.style;
  return n.map(function(g, u) {
    var I = u + i;
    return /* @__PURE__ */ be.createElement("span", {
      key: "line-".concat(u),
      className: "react-syntax-highlighter-line-number",
      style: typeof o == "function" ? o(I) : o
    }, "".concat(I, `
`));
  });
}
function Gn(e) {
  var n = e.codeString, i = e.codeStyle, o = e.containerStyle, g = o === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : o, u = e.numberStyle, I = u === void 0 ? {} : u, M = e.startingLineNumber;
  return /* @__PURE__ */ be.createElement("code", {
    style: Object.assign({}, i, g)
  }, Hn({
    lines: n.replace(/\n$/, "").split(`
`),
    style: I,
    startingLineNumber: M
  }));
}
function Kn(e) {
  return "".concat(e.toString().length, ".25em");
}
function wt(e, n) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: n
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function _t(e, n, i) {
  var o = {
    display: "inline-block",
    minWidth: Kn(i),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, g = typeof e == "function" ? e(n) : e, u = fe(fe({}, o), g);
  return u;
}
function je(e) {
  var n = e.children, i = e.lineNumber, o = e.lineNumberStyle, g = e.largestLineNumber, u = e.showInlineLineNumbers, I = e.lineProps, M = I === void 0 ? {} : I, O = e.className, U = O === void 0 ? [] : O, N = e.showLineNumbers, R = e.wrapLongLines, j = typeof M == "function" ? M(i) : M;
  if (j.className = U, i && u) {
    var l = _t(o, i, g);
    n.unshift(wt(i, l));
  }
  return R & N && (j.style = fe(fe({}, j.style), {}, {
    display: "flex"
  })), {
    type: "element",
    tagName: "span",
    properties: j,
    children: n
  };
}
function xt(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], o = 0; o < e.length; o++) {
    var g = e[o];
    if (g.type === "text")
      i.push(je({
        children: [g],
        className: Mn(new Set(n))
      }));
    else if (g.children) {
      var u = n.concat(g.properties.className);
      xt(g.children, u).forEach(function(I) {
        return i.push(I);
      });
    }
  }
  return i;
}
function Fn(e, n, i, o, g, u, I, M, O) {
  var U, N = xt(e.value), R = [], j = -1, l = 0;
  function W(C, S) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return je({
      children: C,
      lineNumber: S,
      lineNumberStyle: M,
      largestLineNumber: I,
      showInlineLineNumbers: g,
      lineProps: i,
      className: w,
      showLineNumbers: o,
      wrapLongLines: O
    });
  }
  function k(C, S) {
    if (o && S && g) {
      var w = _t(M, S, I);
      C.unshift(wt(S, w));
    }
    return C;
  }
  function y(C, S) {
    var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return n || w.length > 0 ? W(C, S, w) : k(C, S);
  }
  for (var p = function() {
    var S = N[l], w = S.children[0].value, z = Un(w);
    if (z) {
      var K = w.split(`
`);
      K.forEach(function(ce, ee) {
        var X = o && R.length + u, oe = {
          type: "text",
          value: "".concat(ce, `
`)
        };
        if (ee === 0) {
          var re = N.slice(j + 1, l).concat(je({
            children: [oe],
            className: S.properties.className
          })), te = y(re, X);
          R.push(te);
        } else if (ee === K.length - 1) {
          var ae = N[l + 1] && N[l + 1].children && N[l + 1].children[0], Y = {
            type: "text",
            value: "".concat(ce)
          };
          if (ae) {
            var ne = je({
              children: [Y],
              className: S.properties.className
            });
            N.splice(l + 1, 0, ne);
          } else {
            var Z = [Y], ie = y(Z, X, S.properties.className);
            R.push(ie);
          }
        } else {
          var Ee = [oe], xe = y(Ee, X, S.properties.className);
          R.push(xe);
        }
      }), j = l;
    }
    l++;
  }; l < N.length; )
    p();
  if (j !== N.length - 1) {
    var E = N.slice(j + 1, N.length);
    if (E && E.length) {
      var x = o && R.length + u, H = y(E, x);
      R.push(H);
    }
  }
  return n ? R : (U = []).concat.apply(U, R);
}
function Wn(e) {
  var n = e.rows, i = e.stylesheet, o = e.useInlineStyles;
  return n.map(function(g, u) {
    return St({
      node: g,
      stylesheet: i,
      useInlineStyles: o,
      key: "code-segement".concat(u)
    });
  });
}
function Ot(e) {
  return e && typeof e.highlightAuto < "u";
}
function zn(e) {
  var n = e.astGenerator, i = e.language, o = e.code, g = e.defaultCodeValue;
  if (Ot(n)) {
    var u = Dn(n, i);
    return i === "text" ? {
      value: g,
      language: "text"
    } : u ? n.highlight(i, o) : n.highlightAuto(o);
  }
  try {
    return i && i !== "text" ? {
      value: n.highlight(o, i)
    } : {
      value: g
    };
  } catch {
    return {
      value: g
    };
  }
}
function qn(e, n) {
  return function(o) {
    var g = o.language, u = o.children, I = o.style, M = I === void 0 ? n : I, O = o.customStyle, U = O === void 0 ? {} : O, N = o.codeTagProps, R = N === void 0 ? {
      className: g ? "language-".concat(g) : void 0,
      style: fe(fe({}, M['code[class*="language-"]']), M['code[class*="language-'.concat(g, '"]')])
    } : N, j = o.useInlineStyles, l = j === void 0 ? !0 : j, W = o.showLineNumbers, k = W === void 0 ? !1 : W, y = o.showInlineLineNumbers, p = y === void 0 ? !0 : y, E = o.startingLineNumber, x = E === void 0 ? 1 : E, H = o.lineNumberContainerStyle, C = o.lineNumberStyle, S = C === void 0 ? {} : C, w = o.wrapLines, z = o.wrapLongLines, K = z === void 0 ? !1 : z, ce = o.lineProps, ee = ce === void 0 ? {} : ce, X = o.renderer, oe = o.PreTag, re = oe === void 0 ? "pre" : oe, te = o.CodeTag, ae = te === void 0 ? "code" : te, Y = o.code, ne = Y === void 0 ? (Array.isArray(u) ? u[0] : u) || "" : Y, Z = o.astGenerator, ie = xn(o, Bn);
    Z = Z || e;
    var Ee = k ? /* @__PURE__ */ be.createElement(Gn, {
      containerStyle: H,
      codeStyle: R.style || {},
      numberStyle: S,
      startingLineNumber: x,
      codeString: ne
    }) : null, xe = M.hljs || M['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, Re = Ot(Z) ? "hljs" : "prismjs", Ae = l ? Object.assign({}, ie, {
      style: Object.assign({}, xe, U)
    }) : Object.assign({}, ie, {
      className: ie.className ? "".concat(Re, " ").concat(ie.className) : Re,
      style: Object.assign({}, U)
    });
    if (K ? R.style = fe(fe({}, R.style), {}, {
      whiteSpace: "pre-wrap"
    }) : R.style = fe(fe({}, R.style), {}, {
      whiteSpace: "pre"
    }), !Z)
      return /* @__PURE__ */ be.createElement(re, Ae, Ee, /* @__PURE__ */ be.createElement(ae, R, ne));
    (w === void 0 && X || K) && (w = !0), X = X || Wn;
    var Te = [{
      type: "text",
      value: ne
    }], ve = zn({
      astGenerator: Z,
      language: g,
      code: ne,
      defaultCodeValue: Te
    });
    ve.language === null && (ve.value = Te);
    var Qe = ve.value.length + x, Ne = Fn(ve, w, ee, k, p, x, Qe, S, K);
    return /* @__PURE__ */ be.createElement(re, Ae, /* @__PURE__ */ be.createElement(ae, R, !p && Ee, X({
      rows: Ne,
      stylesheet: M,
      useInlineStyles: l
    })));
  };
}
var ye = {}, Ve, pt;
function Vn() {
  if (pt) return Ve;
  pt = 1;
  function e(t) {
    return t instanceof Map ? t.clear = t.delete = t.set = function() {
      throw new Error("map is read-only");
    } : t instanceof Set && (t.add = t.clear = t.delete = function() {
      throw new Error("set is read-only");
    }), Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function(c) {
      var a = t[c];
      typeof a == "object" && !Object.isFrozen(a) && e(a);
    }), t;
  }
  var n = e, i = e;
  n.default = i;
  class o {
    /**
     * @param {CompiledMode} mode
     */
    constructor(c) {
      c.data === void 0 && (c.data = {}), this.data = c.data, this.isMatchIgnored = !1;
    }
    ignoreMatch() {
      this.isMatchIgnored = !0;
    }
  }
  function g(t) {
    return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  }
  function u(t, ...c) {
    const a = /* @__PURE__ */ Object.create(null);
    for (const b in t)
      a[b] = t[b];
    return c.forEach(function(b) {
      for (const D in b)
        a[D] = b[D];
    }), /** @type {T} */
    a;
  }
  const I = "</span>", M = (t) => !!t.kind;
  class O {
    /**
     * Creates a new HTMLRenderer
     *
     * @param {Tree} parseTree - the parse tree (must support `walk` API)
     * @param {{classPrefix: string}} options
     */
    constructor(c, a) {
      this.buffer = "", this.classPrefix = a.classPrefix, c.walk(this);
    }
    /**
     * Adds texts to the output stream
     *
     * @param {string} text */
    addText(c) {
      this.buffer += g(c);
    }
    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
    openNode(c) {
      if (!M(c)) return;
      let a = c.kind;
      c.sublanguage || (a = `${this.classPrefix}${a}`), this.span(a);
    }
    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
    closeNode(c) {
      M(c) && (this.buffer += I);
    }
    /**
     * returns the accumulated buffer
    */
    value() {
      return this.buffer;
    }
    // helpers
    /**
     * Builds a span element
     *
     * @param {string} className */
    span(c) {
      this.buffer += `<span class="${c}">`;
    }
  }
  class U {
    constructor() {
      this.rootNode = { children: [] }, this.stack = [this.rootNode];
    }
    get top() {
      return this.stack[this.stack.length - 1];
    }
    get root() {
      return this.rootNode;
    }
    /** @param {Node} node */
    add(c) {
      this.top.children.push(c);
    }
    /** @param {string} kind */
    openNode(c) {
      const a = { kind: c, children: [] };
      this.add(a), this.stack.push(a);
    }
    closeNode() {
      if (this.stack.length > 1)
        return this.stack.pop();
    }
    closeAllNodes() {
      for (; this.closeNode(); ) ;
    }
    toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }
    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
    walk(c) {
      return this.constructor._walk(c, this.rootNode);
    }
    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
    static _walk(c, a) {
      return typeof a == "string" ? c.addText(a) : a.children && (c.openNode(a), a.children.forEach((b) => this._walk(c, b)), c.closeNode(a)), c;
    }
    /**
     * @param {Node} node
     */
    static _collapse(c) {
      typeof c != "string" && c.children && (c.children.every((a) => typeof a == "string") ? c.children = [c.children.join("")] : c.children.forEach((a) => {
        U._collapse(a);
      }));
    }
  }
  class N extends U {
    /**
     * @param {*} options
     */
    constructor(c) {
      super(), this.options = c;
    }
    /**
     * @param {string} text
     * @param {string} kind
     */
    addKeyword(c, a) {
      c !== "" && (this.openNode(a), this.addText(c), this.closeNode());
    }
    /**
     * @param {string} text
     */
    addText(c) {
      c !== "" && this.add(c);
    }
    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
    addSublanguage(c, a) {
      const b = c.root;
      b.kind = a, b.sublanguage = !0, this.add(b);
    }
    toHTML() {
      return new O(this, this.options).value();
    }
    finalize() {
      return !0;
    }
  }
  function R(t) {
    return new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
  }
  function j(t) {
    return t ? typeof t == "string" ? t : t.source : null;
  }
  function l(...t) {
    return t.map((a) => j(a)).join("");
  }
  function W(...t) {
    return "(" + t.map((a) => j(a)).join("|") + ")";
  }
  function k(t) {
    return new RegExp(t.toString() + "|").exec("").length - 1;
  }
  function y(t, c) {
    const a = t && t.exec(c);
    return a && a.index === 0;
  }
  const p = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
  function E(t, c = "|") {
    let a = 0;
    return t.map((b) => {
      a += 1;
      const D = a;
      let P = j(b), q = "";
      for (; P.length > 0; ) {
        const r = p.exec(P);
        if (!r) {
          q += P;
          break;
        }
        q += P.substring(0, r.index), P = P.substring(r.index + r[0].length), r[0][0] === "\\" && r[1] ? q += "\\" + String(Number(r[1]) + D) : (q += r[0], r[0] === "(" && a++);
      }
      return q;
    }).map((b) => `(${b})`).join(c);
  }
  const x = /\b\B/, H = "[a-zA-Z]\\w*", C = "[a-zA-Z_]\\w*", S = "\\b\\d+(\\.\\d+)?", w = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", z = "\\b(0b[01]+)", K = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", ce = (t = {}) => {
    const c = /^#![ ]*\//;
    return t.binary && (t.begin = l(
      c,
      /.*\b/,
      t.binary,
      /\b.*/
    )), u({
      className: "meta",
      begin: c,
      end: /$/,
      relevance: 0,
      /** @type {ModeCallback} */
      "on:begin": (a, b) => {
        a.index !== 0 && b.ignoreMatch();
      }
    }, t);
  }, ee = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
  }, X = {
    className: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [ee]
  }, oe = {
    className: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [ee]
  }, re = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  }, te = function(t, c, a = {}) {
    const b = u(
      {
        className: "comment",
        begin: t,
        end: c,
        contains: []
      },
      a
    );
    return b.contains.push(re), b.contains.push({
      className: "doctag",
      begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
      relevance: 0
    }), b;
  }, ae = te("//", "$"), Y = te("/\\*", "\\*/"), ne = te("#", "$"), Z = {
    className: "number",
    begin: S,
    relevance: 0
  }, ie = {
    className: "number",
    begin: w,
    relevance: 0
  }, Ee = {
    className: "number",
    begin: z,
    relevance: 0
  }, xe = {
    className: "number",
    begin: S + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  }, Re = {
    // this outer rule makes sure we actually have a WHOLE regex and not simply
    // an expression such as:
    //
    //     3 / something
    //
    // (which will then blow up when regex's `illegal` sees the newline)
    begin: /(?=\/[^/\n]*\/)/,
    contains: [{
      className: "regexp",
      begin: /\//,
      end: /\/[gimuy]*/,
      illegal: /\n/,
      contains: [
        ee,
        {
          begin: /\[/,
          end: /\]/,
          relevance: 0,
          contains: [ee]
        }
      ]
    }]
  }, Ae = {
    className: "title",
    begin: H,
    relevance: 0
  }, Te = {
    className: "title",
    begin: C,
    relevance: 0
  }, ve = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + C,
    relevance: 0
  };
  var Ne = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: x,
    IDENT_RE: H,
    UNDERSCORE_IDENT_RE: C,
    NUMBER_RE: S,
    C_NUMBER_RE: w,
    BINARY_NUMBER_RE: z,
    RE_STARTERS_RE: K,
    SHEBANG: ce,
    BACKSLASH_ESCAPE: ee,
    APOS_STRING_MODE: X,
    QUOTE_STRING_MODE: oe,
    PHRASAL_WORDS_MODE: re,
    COMMENT: te,
    C_LINE_COMMENT_MODE: ae,
    C_BLOCK_COMMENT_MODE: Y,
    HASH_COMMENT_MODE: ne,
    NUMBER_MODE: Z,
    C_NUMBER_MODE: ie,
    BINARY_NUMBER_MODE: Ee,
    CSS_NUMBER_MODE: xe,
    REGEXP_MODE: Re,
    TITLE_MODE: Ae,
    UNDERSCORE_TITLE_MODE: Te,
    METHOD_GUARD: ve,
    END_SAME_AS_BEGIN: function(t) {
      return Object.assign(
        t,
        {
          /** @type {ModeCallback} */
          "on:begin": (c, a) => {
            a.data._beginMatch = c[1];
          },
          /** @type {ModeCallback} */
          "on:end": (c, a) => {
            a.data._beginMatch !== c[1] && a.ignoreMatch();
          }
        }
      );
    }
  });
  function Tt(t, c) {
    t.input[t.index - 1] === "." && c.ignoreMatch();
  }
  function Mt(t, c) {
    c && t.beginKeywords && (t.begin = "\\b(" + t.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", t.__beforeBegin = Tt, t.keywords = t.keywords || t.beginKeywords, delete t.beginKeywords, t.relevance === void 0 && (t.relevance = 0));
  }
  function Lt(t, c) {
    Array.isArray(t.illegal) && (t.illegal = W(...t.illegal));
  }
  function It(t, c) {
    if (t.match) {
      if (t.begin || t.end) throw new Error("begin & end are not supported with match");
      t.begin = t.match, delete t.match;
    }
  }
  function kt(t, c) {
    t.relevance === void 0 && (t.relevance = 1);
  }
  const Ct = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
    // common variable name
  ], Pt = "keyword";
  function et(t, c, a = Pt) {
    const b = {};
    return typeof t == "string" ? D(a, t.split(" ")) : Array.isArray(t) ? D(a, t) : Object.keys(t).forEach(function(P) {
      Object.assign(
        b,
        et(t[P], c, P)
      );
    }), b;
    function D(P, q) {
      c && (q = q.map((r) => r.toLowerCase())), q.forEach(function(r) {
        const d = r.split("|");
        b[d[0]] = [P, jt(d[0], d[1])];
      });
    }
  }
  function jt(t, c) {
    return c ? Number(c) : Dt(t) ? 0 : 1;
  }
  function Dt(t) {
    return Ct.includes(t.toLowerCase());
  }
  function Bt(t, { plugins: c }) {
    function a(r, d) {
      return new RegExp(
        j(r),
        "m" + (t.case_insensitive ? "i" : "") + (d ? "g" : "")
      );
    }
    class b {
      constructor() {
        this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
      }
      // @ts-ignore
      addRule(d, v) {
        v.position = this.position++, this.matchIndexes[this.matchAt] = v, this.regexes.push([v, d]), this.matchAt += k(d) + 1;
      }
      compile() {
        this.regexes.length === 0 && (this.exec = () => null);
        const d = this.regexes.map((v) => v[1]);
        this.matcherRe = a(E(d), !0), this.lastIndex = 0;
      }
      /** @param {string} s */
      exec(d) {
        this.matcherRe.lastIndex = this.lastIndex;
        const v = this.matcherRe.exec(d);
        if (!v)
          return null;
        const _ = v.findIndex((he, Ue) => Ue > 0 && he !== void 0), G = this.matchIndexes[_];
        return v.splice(0, _), Object.assign(v, G);
      }
    }
    class D {
      constructor() {
        this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
      }
      // @ts-ignore
      getMatcher(d) {
        if (this.multiRegexes[d]) return this.multiRegexes[d];
        const v = new b();
        return this.rules.slice(d).forEach(([_, G]) => v.addRule(_, G)), v.compile(), this.multiRegexes[d] = v, v;
      }
      resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
      considerAll() {
        this.regexIndex = 0;
      }
      // @ts-ignore
      addRule(d, v) {
        this.rules.push([d, v]), v.type === "begin" && this.count++;
      }
      /** @param {string} s */
      exec(d) {
        const v = this.getMatcher(this.regexIndex);
        v.lastIndex = this.lastIndex;
        let _ = v.exec(d);
        if (this.resumingScanAtSamePosition() && !(_ && _.index === this.lastIndex)) {
          const G = this.getMatcher(0);
          G.lastIndex = this.lastIndex + 1, _ = G.exec(d);
        }
        return _ && (this.regexIndex += _.position + 1, this.regexIndex === this.count && this.considerAll()), _;
      }
    }
    function P(r) {
      const d = new D();
      return r.contains.forEach((v) => d.addRule(v.begin, { rule: v, type: "begin" })), r.terminatorEnd && d.addRule(r.terminatorEnd, { type: "end" }), r.illegal && d.addRule(r.illegal, { type: "illegal" }), d;
    }
    function q(r, d) {
      const v = (
        /** @type CompiledMode */
        r
      );
      if (r.isCompiled) return v;
      [
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        It
      ].forEach((G) => G(r, d)), t.compilerExtensions.forEach((G) => G(r, d)), r.__beforeBegin = null, [
        Mt,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        Lt,
        // default to 1 relevance if not specified
        kt
      ].forEach((G) => G(r, d)), r.isCompiled = !0;
      let _ = null;
      if (typeof r.keywords == "object" && (_ = r.keywords.$pattern, delete r.keywords.$pattern), r.keywords && (r.keywords = et(r.keywords, t.case_insensitive)), r.lexemes && _)
        throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
      return _ = _ || r.lexemes || /\w+/, v.keywordPatternRe = a(_, !0), d && (r.begin || (r.begin = /\B|\b/), v.beginRe = a(r.begin), r.endSameAsBegin && (r.end = r.begin), !r.end && !r.endsWithParent && (r.end = /\B|\b/), r.end && (v.endRe = a(r.end)), v.terminatorEnd = j(r.end) || "", r.endsWithParent && d.terminatorEnd && (v.terminatorEnd += (r.end ? "|" : "") + d.terminatorEnd)), r.illegal && (v.illegalRe = a(
        /** @type {RegExp | string} */
        r.illegal
      )), r.contains || (r.contains = []), r.contains = [].concat(...r.contains.map(function(G) {
        return $t(G === "self" ? r : G);
      })), r.contains.forEach(function(G) {
        q(
          /** @type Mode */
          G,
          v
        );
      }), r.starts && q(r.starts, d), v.matcher = P(v), v;
    }
    if (t.compilerExtensions || (t.compilerExtensions = []), t.contains && t.contains.includes("self"))
      throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    return t.classNameAliases = u(t.classNameAliases || {}), q(
      /** @type Mode */
      t
    );
  }
  function tt(t) {
    return t ? t.endsWithParent || tt(t.starts) : !1;
  }
  function $t(t) {
    return t.variants && !t.cachedVariants && (t.cachedVariants = t.variants.map(function(c) {
      return u(t, { variants: null }, c);
    })), t.cachedVariants ? t.cachedVariants : tt(t) ? u(t, { starts: t.starts ? u(t.starts) : null }) : Object.isFrozen(t) ? u(t) : t;
  }
  var Ut = "10.7.3";
  function Ht(t) {
    return !!(t || t === "");
  }
  function Gt(t) {
    const c = {
      props: ["language", "code", "autodetect"],
      data: function() {
        return {
          detectedLanguage: "",
          unknownLanguage: !1
        };
      },
      computed: {
        className() {
          return this.unknownLanguage ? "" : "hljs " + this.detectedLanguage;
        },
        highlighted() {
          if (!this.autoDetect && !t.getLanguage(this.language))
            return console.warn(`The language "${this.language}" you specified could not be found.`), this.unknownLanguage = !0, g(this.code);
          let b = {};
          return this.autoDetect ? (b = t.highlightAuto(this.code), this.detectedLanguage = b.language) : (b = t.highlight(this.language, this.code, this.ignoreIllegals), this.detectedLanguage = this.language), b.value;
        },
        autoDetect() {
          return !this.language || Ht(this.autodetect);
        },
        ignoreIllegals() {
          return !0;
        }
      },
      // this avoids needing to use a whole Vue compilation pipeline just
      // to build Highlight.js
      render(b) {
        return b("pre", {}, [
          b("code", {
            class: this.className,
            domProps: { innerHTML: this.highlighted }
          })
        ]);
      }
      // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
    };
    return { Component: c, VuePlugin: {
      install(b) {
        b.component("highlightjs", c);
      }
    } };
  }
  const Kt = {
    "after:highlightElement": ({ el: t, result: c, text: a }) => {
      const b = nt(t);
      if (!b.length) return;
      const D = document.createElement("div");
      D.innerHTML = c.value, c.value = Ft(b, nt(D), a);
    }
  };
  function De(t) {
    return t.nodeName.toLowerCase();
  }
  function nt(t) {
    const c = [];
    return function a(b, D) {
      for (let P = b.firstChild; P; P = P.nextSibling)
        P.nodeType === 3 ? D += P.nodeValue.length : P.nodeType === 1 && (c.push({
          event: "start",
          offset: D,
          node: P
        }), D = a(P, D), De(P).match(/br|hr|img|input/) || c.push({
          event: "stop",
          offset: D,
          node: P
        }));
      return D;
    }(t, 0), c;
  }
  function Ft(t, c, a) {
    let b = 0, D = "";
    const P = [];
    function q() {
      return !t.length || !c.length ? t.length ? t : c : t[0].offset !== c[0].offset ? t[0].offset < c[0].offset ? t : c : c[0].event === "start" ? t : c;
    }
    function r(_) {
      function G(he) {
        return " " + he.nodeName + '="' + g(he.value) + '"';
      }
      D += "<" + De(_) + [].map.call(_.attributes, G).join("") + ">";
    }
    function d(_) {
      D += "</" + De(_) + ">";
    }
    function v(_) {
      (_.event === "start" ? r : d)(_.node);
    }
    for (; t.length || c.length; ) {
      let _ = q();
      if (D += g(a.substring(b, _[0].offset)), b = _[0].offset, _ === t) {
        P.reverse().forEach(d);
        do
          v(_.splice(0, 1)[0]), _ = q();
        while (_ === t && _.length && _[0].offset === b);
        P.reverse().forEach(r);
      } else
        _[0].event === "start" ? P.push(_[0].node) : P.pop(), v(_.splice(0, 1)[0]);
    }
    return D + g(a.substr(b));
  }
  const ct = {}, Be = (t) => {
    console.error(t);
  }, ot = (t, ...c) => {
    console.log(`WARN: ${t}`, ...c);
  }, se = (t, c) => {
    ct[`${t}/${c}`] || (console.log(`Deprecated as of ${t}. ${c}`), ct[`${t}/${c}`] = !0);
  }, $e = g, it = u, st = Symbol("nomatch");
  var Wt = function(t) {
    const c = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null), b = [];
    let D = !0;
    const P = /(^(<[^>]+>|\t|)+|\n)/gm, q = "Could not find the language '{}', did you forget to load/include a language module?", r = { disableAutodetect: !0, name: "Plain text", contains: [] };
    let d = {
      noHighlightRe: /^(no-?highlight)$/i,
      languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
      classPrefix: "hljs-",
      tabReplace: null,
      useBR: !1,
      languages: null,
      // beta configuration options, subject to change, welcome to discuss
      // https://github.com/highlightjs/highlight.js/issues/1086
      __emitter: N
    };
    function v(s) {
      return d.noHighlightRe.test(s);
    }
    function _(s) {
      let f = s.className + " ";
      f += s.parentNode ? s.parentNode.className : "";
      const L = d.languageDetectRe.exec(f);
      if (L) {
        const $ = de(L[1]);
        return $ || (ot(q.replace("{}", L[1])), ot("Falling back to no-highlight mode for this block.", s)), $ ? L[1] : "no-highlight";
      }
      return f.split(/\s+/).find(($) => v($) || de($));
    }
    function G(s, f, L, $) {
      let V = "", me = "";
      typeof f == "object" ? (V = s, L = f.ignoreIllegals, me = f.language, $ = void 0) : (se("10.7.0", "highlight(lang, code, ...args) has been deprecated."), se("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), me = s, V = f);
      const le = {
        code: V,
        language: me
      };
      Le("before:highlight", le);
      const ue = le.result ? le.result : he(le.language, le.code, L, $);
      return ue.code = le.code, Le("after:highlight", ue), ue;
    }
    function he(s, f, L, $) {
      function V(h, m) {
        const T = Se.case_insensitive ? m[0].toLowerCase() : m[0];
        return Object.prototype.hasOwnProperty.call(h.keywords, T) && h.keywords[T];
      }
      function me() {
        if (!A.keywords) {
          J.addText(F);
          return;
        }
        let h = 0;
        A.keywordPatternRe.lastIndex = 0;
        let m = A.keywordPatternRe.exec(F), T = "";
        for (; m; ) {
          T += F.substring(h, m.index);
          const B = V(A, m);
          if (B) {
            const [Q, Ce] = B;
            if (J.addText(T), T = "", ke += Ce, Q.startsWith("_"))
              T += m[0];
            else {
              const hn = Se.classNameAliases[Q] || Q;
              J.addKeyword(m[0], hn);
            }
          } else
            T += m[0];
          h = A.keywordPatternRe.lastIndex, m = A.keywordPatternRe.exec(F);
        }
        T += F.substr(h), J.addText(T);
      }
      function le() {
        if (F === "") return;
        let h = null;
        if (typeof A.subLanguage == "string") {
          if (!c[A.subLanguage]) {
            J.addText(F);
            return;
          }
          h = he(A.subLanguage, F, !0, gt[A.subLanguage]), gt[A.subLanguage] = /** @type {CompiledMode} */
          h.top;
        } else
          h = He(F, A.subLanguage.length ? A.subLanguage : null);
        A.relevance > 0 && (ke += h.relevance), J.addSublanguage(h.emitter, h.language);
      }
      function ue() {
        A.subLanguage != null ? le() : me(), F = "";
      }
      function ge(h) {
        return h.className && J.openNode(Se.classNameAliases[h.className] || h.className), A = Object.create(h, { parent: { value: A } }), A;
      }
      function pe(h, m, T) {
        let B = y(h.endRe, T);
        if (B) {
          if (h["on:end"]) {
            const Q = new o(h);
            h["on:end"](m, Q), Q.isMatchIgnored && (B = !1);
          }
          if (B) {
            for (; h.endsParent && h.parent; )
              h = h.parent;
            return h;
          }
        }
        if (h.endsWithParent)
          return pe(h.parent, m, T);
      }
      function ln(h) {
        return A.matcher.regexIndex === 0 ? (F += h[0], 1) : (ze = !0, 0);
      }
      function un(h) {
        const m = h[0], T = h.rule, B = new o(T), Q = [T.__beforeBegin, T["on:begin"]];
        for (const Ce of Q)
          if (Ce && (Ce(h, B), B.isMatchIgnored))
            return ln(m);
        return T && T.endSameAsBegin && (T.endRe = R(m)), T.skip ? F += m : (T.excludeBegin && (F += m), ue(), !T.returnBegin && !T.excludeBegin && (F = m)), ge(T), T.returnBegin ? 0 : m.length;
      }
      function gn(h) {
        const m = h[0], T = f.substr(h.index), B = pe(A, h, T);
        if (!B)
          return st;
        const Q = A;
        Q.skip ? F += m : (Q.returnEnd || Q.excludeEnd || (F += m), ue(), Q.excludeEnd && (F = m));
        do
          A.className && J.closeNode(), !A.skip && !A.subLanguage && (ke += A.relevance), A = A.parent;
        while (A !== B.parent);
        return B.starts && (B.endSameAsBegin && (B.starts.endRe = B.endRe), ge(B.starts)), Q.returnEnd ? 0 : m.length;
      }
      function fn() {
        const h = [];
        for (let m = A; m !== Se; m = m.parent)
          m.className && h.unshift(m.className);
        h.forEach((m) => J.openNode(m));
      }
      let Ie = {};
      function ut(h, m) {
        const T = m && m[0];
        if (F += h, T == null)
          return ue(), 0;
        if (Ie.type === "begin" && m.type === "end" && Ie.index === m.index && T === "") {
          if (F += f.slice(m.index, m.index + 1), !D) {
            const B = new Error("0 width match regex");
            throw B.languageName = s, B.badRule = Ie.rule, B;
          }
          return 1;
        }
        if (Ie = m, m.type === "begin")
          return un(m);
        if (m.type === "illegal" && !L) {
          const B = new Error('Illegal lexeme "' + T + '" for mode "' + (A.className || "<unnamed>") + '"');
          throw B.mode = A, B;
        } else if (m.type === "end") {
          const B = gn(m);
          if (B !== st)
            return B;
        }
        if (m.type === "illegal" && T === "")
          return 1;
        if (We > 1e5 && We > m.index * 3)
          throw new Error("potential infinite loop, way more iterations than matches");
        return F += T, T.length;
      }
      const Se = de(s);
      if (!Se)
        throw Be(q.replace("{}", s)), new Error('Unknown language: "' + s + '"');
      const dn = Bt(Se, { plugins: b });
      let Fe = "", A = $ || dn;
      const gt = {}, J = new d.__emitter(d);
      fn();
      let F = "", ke = 0, we = 0, We = 0, ze = !1;
      try {
        for (A.matcher.considerAll(); ; ) {
          We++, ze ? ze = !1 : A.matcher.considerAll(), A.matcher.lastIndex = we;
          const h = A.matcher.exec(f);
          if (!h) break;
          const m = f.substring(we, h.index), T = ut(m, h);
          we = h.index + T;
        }
        return ut(f.substr(we)), J.closeAllNodes(), J.finalize(), Fe = J.toHTML(), {
          // avoid possible breakage with v10 clients expecting
          // this to always be an integer
          relevance: Math.floor(ke),
          value: Fe,
          language: s,
          illegal: !1,
          emitter: J,
          top: A
        };
      } catch (h) {
        if (h.message && h.message.includes("Illegal"))
          return {
            illegal: !0,
            illegalBy: {
              msg: h.message,
              context: f.slice(we - 100, we + 100),
              mode: h.mode
            },
            sofar: Fe,
            relevance: 0,
            value: $e(f),
            emitter: J
          };
        if (D)
          return {
            illegal: !1,
            relevance: 0,
            value: $e(f),
            emitter: J,
            language: s,
            top: A,
            errorRaised: h
          };
        throw h;
      }
    }
    function Ue(s) {
      const f = {
        relevance: 0,
        emitter: new d.__emitter(d),
        value: $e(s),
        illegal: !1,
        top: r
      };
      return f.emitter.addText(s), f;
    }
    function He(s, f) {
      f = f || d.languages || Object.keys(c);
      const L = Ue(s), $ = f.filter(de).filter(lt).map(
        (ge) => he(ge, s, !1)
      );
      $.unshift(L);
      const V = $.sort((ge, pe) => {
        if (ge.relevance !== pe.relevance) return pe.relevance - ge.relevance;
        if (ge.language && pe.language) {
          if (de(ge.language).supersetOf === pe.language)
            return 1;
          if (de(pe.language).supersetOf === ge.language)
            return -1;
        }
        return 0;
      }), [me, le] = V, ue = me;
      return ue.second_best = le, ue;
    }
    function zt(s) {
      return d.tabReplace || d.useBR ? s.replace(P, (f) => f === `
` ? d.useBR ? "<br>" : f : d.tabReplace ? f.replace(/\t/g, d.tabReplace) : f) : s;
    }
    function qt(s, f, L) {
      const $ = f ? a[f] : L;
      s.classList.add("hljs"), $ && s.classList.add($);
    }
    const Vt = {
      "before:highlightElement": ({ el: s }) => {
        d.useBR && (s.innerHTML = s.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, `
`));
      },
      "after:highlightElement": ({ result: s }) => {
        d.useBR && (s.value = s.value.replace(/\n/g, "<br>"));
      }
    }, Xt = /^(<[^>]+>|\t)+/gm, Yt = {
      "after:highlightElement": ({ result: s }) => {
        d.tabReplace && (s.value = s.value.replace(
          Xt,
          (f) => f.replace(/\t/g, d.tabReplace)
        ));
      }
    };
    function Me(s) {
      let f = null;
      const L = _(s);
      if (v(L)) return;
      Le(
        "before:highlightElement",
        { el: s, language: L }
      ), f = s;
      const $ = f.textContent, V = L ? G($, { language: L, ignoreIllegals: !0 }) : He($);
      Le("after:highlightElement", { el: s, result: V, text: $ }), s.innerHTML = V.value, qt(s, L, V.language), s.result = {
        language: V.language,
        // TODO: remove with version 11.0
        re: V.relevance,
        relavance: V.relevance
      }, V.second_best && (s.second_best = {
        language: V.second_best.language,
        // TODO: remove with version 11.0
        re: V.second_best.relevance,
        relavance: V.second_best.relevance
      });
    }
    function Jt(s) {
      s.useBR && (se("10.3.0", "'useBR' will be removed entirely in v11.0"), se("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559")), d = it(d, s);
    }
    const Ge = () => {
      if (Ge.called) return;
      Ge.called = !0, se("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead."), document.querySelectorAll("pre code").forEach(Me);
    };
    function Zt() {
      se("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."), Ke = !0;
    }
    let Ke = !1;
    function at() {
      if (document.readyState === "loading") {
        Ke = !0;
        return;
      }
      document.querySelectorAll("pre code").forEach(Me);
    }
    function Qt() {
      Ke && at();
    }
    typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", Qt, !1);
    function en(s, f) {
      let L = null;
      try {
        L = f(t);
      } catch ($) {
        if (Be("Language definition for '{}' could not be registered.".replace("{}", s)), D)
          Be($);
        else
          throw $;
        L = r;
      }
      L.name || (L.name = s), c[s] = L, L.rawDefinition = f.bind(null, t), L.aliases && rt(L.aliases, { languageName: s });
    }
    function tn(s) {
      delete c[s];
      for (const f of Object.keys(a))
        a[f] === s && delete a[f];
    }
    function nn() {
      return Object.keys(c);
    }
    function cn(s) {
      se("10.4.0", "requireLanguage will be removed entirely in v11."), se("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
      const f = de(s);
      if (f)
        return f;
      throw new Error("The '{}' language is required, but not loaded.".replace("{}", s));
    }
    function de(s) {
      return s = (s || "").toLowerCase(), c[s] || c[a[s]];
    }
    function rt(s, { languageName: f }) {
      typeof s == "string" && (s = [s]), s.forEach((L) => {
        a[L.toLowerCase()] = f;
      });
    }
    function lt(s) {
      const f = de(s);
      return f && !f.disableAutodetect;
    }
    function on(s) {
      s["before:highlightBlock"] && !s["before:highlightElement"] && (s["before:highlightElement"] = (f) => {
        s["before:highlightBlock"](
          Object.assign({ block: f.el }, f)
        );
      }), s["after:highlightBlock"] && !s["after:highlightElement"] && (s["after:highlightElement"] = (f) => {
        s["after:highlightBlock"](
          Object.assign({ block: f.el }, f)
        );
      });
    }
    function sn(s) {
      on(s), b.push(s);
    }
    function Le(s, f) {
      const L = s;
      b.forEach(function($) {
        $[L] && $[L](f);
      });
    }
    function an(s) {
      return se("10.2.0", "fixMarkup will be removed entirely in v11.0"), se("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534"), zt(s);
    }
    function rn(s) {
      return se("10.7.0", "highlightBlock will be removed entirely in v12.0"), se("10.7.0", "Please use highlightElement now."), Me(s);
    }
    Object.assign(t, {
      highlight: G,
      highlightAuto: He,
      highlightAll: at,
      fixMarkup: an,
      highlightElement: Me,
      // TODO: Remove with v12 API
      highlightBlock: rn,
      configure: Jt,
      initHighlighting: Ge,
      initHighlightingOnLoad: Zt,
      registerLanguage: en,
      unregisterLanguage: tn,
      listLanguages: nn,
      getLanguage: de,
      registerAliases: rt,
      requireLanguage: cn,
      autoDetection: lt,
      inherit: it,
      addPlugin: sn,
      // plugins for frameworks
      vuePlugin: Gt(t).VuePlugin
    }), t.debugMode = function() {
      D = !1;
    }, t.safeMode = function() {
      D = !0;
    }, t.versionString = Ut;
    for (const s in Ne)
      typeof Ne[s] == "object" && n(Ne[s]);
    return Object.assign(t, Ne), t.addPlugin(Vt), t.addPlugin(Kt), t.addPlugin(Yt), t;
  }({});
  return Ve = Wt, Ve;
}
var Xe = { exports: {} }, bt;
function Xn() {
  return bt || (bt = 1, function(e) {
    (function() {
      var n;
      n = e.exports = g, n.format = g, n.vsprintf = o, typeof console < "u" && typeof console.log == "function" && (n.printf = i);
      function i() {
        console.log(g.apply(null, arguments));
      }
      function o(u, I) {
        return g.apply(null, [u].concat(I));
      }
      function g(u) {
        for (var I = 1, M = [].slice.call(arguments), O = 0, U = u.length, N = "", R, j = !1, l, W, k = !1, y, p = function() {
          return M[I++];
        }, E = function() {
          for (var x = ""; /\d/.test(u[O]); )
            x += u[O++], R = u[O];
          return x.length > 0 ? parseInt(x) : null;
        }; O < U; ++O)
          if (R = u[O], j)
            switch (j = !1, R == "." ? (k = !1, R = u[++O]) : R == "0" && u[O + 1] == "." ? (k = !0, O += 2, R = u[O]) : k = !0, y = E(), R) {
              case "b":
                N += parseInt(p(), 10).toString(2);
                break;
              case "c":
                l = p(), typeof l == "string" || l instanceof String ? N += l : N += String.fromCharCode(parseInt(l, 10));
                break;
              case "d":
                N += parseInt(p(), 10);
                break;
              case "f":
                W = String(parseFloat(p()).toFixed(y || 6)), N += k ? W : W.replace(/^0/, "");
                break;
              case "j":
                N += JSON.stringify(p());
                break;
              case "o":
                N += "0" + parseInt(p(), 10).toString(8);
                break;
              case "s":
                N += p();
                break;
              case "x":
                N += "0x" + parseInt(p(), 10).toString(16);
                break;
              case "X":
                N += "0x" + parseInt(p(), 10).toString(16).toUpperCase();
                break;
              default:
                N += R;
                break;
            }
          else R === "%" ? j = !0 : N += R;
        return N;
      }
    })();
  }(Xe)), Xe.exports;
}
var Ye, mt;
function Yn() {
  if (mt) return Ye;
  mt = 1;
  var e = Xn(), n = i(Error);
  Ye = n, n.eval = i(EvalError), n.range = i(RangeError), n.reference = i(ReferenceError), n.syntax = i(SyntaxError), n.type = i(TypeError), n.uri = i(URIError), n.create = i;
  function i(o) {
    return g.displayName = o.displayName || o.name, g;
    function g(u) {
      return u && (u = e.apply(null, arguments)), new o(u);
    }
  }
  return Ye;
}
var yt;
function Jn() {
  if (yt) return ye;
  yt = 1;
  var e = Vn(), n = Yn();
  ye.highlight = o, ye.highlightAuto = g, ye.registerLanguage = u, ye.listLanguages = I, ye.registerAlias = M, O.prototype.addText = R, O.prototype.addKeyword = U, O.prototype.addSublanguage = N, O.prototype.openNode = j, O.prototype.closeNode = l, O.prototype.closeAllNodes = k, O.prototype.finalize = k, O.prototype.toHTML = W;
  var i = "hljs-";
  function o(y, p, E) {
    var x = e.configure({}), H = E || {}, C = H.prefix, S;
    if (typeof y != "string")
      throw n("Expected `string` for name, got `%s`", y);
    if (!e.getLanguage(y))
      throw n("Unknown language: `%s` is not registered", y);
    if (typeof p != "string")
      throw n("Expected `string` for value, got `%s`", p);
    if (C == null && (C = i), e.configure({ __emitter: O, classPrefix: C }), S = e.highlight(p, { language: y, ignoreIllegals: !0 }), e.configure(x || {}), S.errorRaised)
      throw S.errorRaised;
    return {
      relevance: S.relevance,
      language: S.language,
      value: S.emitter.rootNode.children
    };
  }
  function g(y, p) {
    var E = p || {}, x = E.subset || e.listLanguages();
    E.prefix;
    var H = x.length, C = -1, S, w, z, K;
    if (typeof y != "string")
      throw n("Expected `string` for value, got `%s`", y);
    for (w = { relevance: 0, language: null, value: [] }, S = { relevance: 0, language: null, value: [] }; ++C < H; )
      K = x[C], e.getLanguage(K) && (z = o(K, y, p), z.language = K, z.relevance > w.relevance && (w = z), z.relevance > S.relevance && (w = S, S = z));
    return w.language && (S.secondBest = w), S;
  }
  function u(y, p) {
    e.registerLanguage(y, p);
  }
  function I() {
    return e.listLanguages();
  }
  function M(y, p) {
    var E = y, x;
    p && (E = {}, E[y] = p);
    for (x in E)
      e.registerAliases(E[x], { languageName: x });
  }
  function O(y) {
    this.options = y, this.rootNode = { children: [] }, this.stack = [this.rootNode];
  }
  function U(y, p) {
    this.openNode(p), this.addText(y), this.closeNode();
  }
  function N(y, p) {
    var E = this.stack, x = E[E.length - 1], H = y.rootNode.children, C = p ? {
      type: "element",
      tagName: "span",
      properties: { className: [p] },
      children: H
    } : H;
    x.children = x.children.concat(C);
  }
  function R(y) {
    var p = this.stack, E, x;
    y !== "" && (E = p[p.length - 1], x = E.children[E.children.length - 1], x && x.type === "text" ? x.value += y : E.children.push({ type: "text", value: y }));
  }
  function j(y) {
    var p = this.stack, E = this.options.classPrefix + y, x = p[p.length - 1], H = {
      type: "element",
      tagName: "span",
      properties: { className: [E] },
      children: []
    };
    x.children.push(H), p.push(H);
  }
  function l() {
    this.stack.pop();
  }
  function W() {
    return "";
  }
  function k() {
  }
  return ye;
}
var Je, Et;
function Zn() {
  if (Et) return Je;
  Et = 1;
  const e = "[A-Za-z$_][0-9A-Za-z$_]*", n = [
    "as",
    // for exports
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
  ], i = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
  ], o = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
  ], g = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
  ], u = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
  ], I = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global"
    // Node.js
  ], M = [].concat(
    u,
    I,
    o,
    g
  );
  function O(l) {
    return l ? typeof l == "string" ? l : l.source : null;
  }
  function U(l) {
    return N("(?=", l, ")");
  }
  function N(...l) {
    return l.map((k) => O(k)).join("");
  }
  function R(l) {
    const W = (Y, { after: ne }) => {
      const Z = "</" + Y[0].slice(1);
      return Y.input.indexOf(Z, ne) !== -1;
    }, k = e, y = {
      begin: "<>",
      end: "</>"
    }, p = {
      begin: /<[A-Za-z0-9\\._:-]+/,
      end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
      /**
       * @param {RegExpMatchArray} match
       * @param {CallbackResponse} response
       */
      isTrulyOpeningTag: (Y, ne) => {
        const Z = Y[0].length + Y.index, ie = Y.input[Z];
        if (ie === "<") {
          ne.ignoreMatch();
          return;
        }
        ie === ">" && (W(Y, { after: Z }) || ne.ignoreMatch());
      }
    }, E = {
      $pattern: e,
      keyword: n,
      literal: i,
      built_in: M
    }, x = "[0-9](_?[0-9])*", H = `\\.(${x})`, C = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", S = {
      className: "number",
      variants: [
        // DecimalLiteral
        { begin: `(\\b(${C})((${H})|\\.)?|(${H}))[eE][+-]?(${x})\\b` },
        { begin: `\\b(${C})\\b((${H})\\b|\\.)?|(${H})\\b` },
        // DecimalBigIntegerLiteral
        { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
        // NonDecimalIntegerLiteral
        { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
        { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
        { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
        // LegacyOctalIntegerLiteral (does not include underscore separators)
        // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
        { begin: "\\b0[0-7]+n?\\b" }
      ],
      relevance: 0
    }, w = {
      className: "subst",
      begin: "\\$\\{",
      end: "\\}",
      keywords: E,
      contains: []
      // defined later
    }, z = {
      begin: "html`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          l.BACKSLASH_ESCAPE,
          w
        ],
        subLanguage: "xml"
      }
    }, K = {
      begin: "css`",
      end: "",
      starts: {
        end: "`",
        returnEnd: !1,
        contains: [
          l.BACKSLASH_ESCAPE,
          w
        ],
        subLanguage: "css"
      }
    }, ce = {
      className: "string",
      begin: "`",
      end: "`",
      contains: [
        l.BACKSLASH_ESCAPE,
        w
      ]
    }, X = {
      className: "comment",
      variants: [
        l.COMMENT(
          /\/\*\*(?!\/)/,
          "\\*/",
          {
            relevance: 0,
            contains: [
              {
                className: "doctag",
                begin: "@[A-Za-z]+",
                contains: [
                  {
                    className: "type",
                    begin: "\\{",
                    end: "\\}",
                    relevance: 0
                  },
                  {
                    className: "variable",
                    begin: k + "(?=\\s*(-)|$)",
                    endsParent: !0,
                    relevance: 0
                  },
                  // eat spaces (not newlines) so we can find
                  // types or variables
                  {
                    begin: /(?=[^\n])\s/,
                    relevance: 0
                  }
                ]
              }
            ]
          }
        ),
        l.C_BLOCK_COMMENT_MODE,
        l.C_LINE_COMMENT_MODE
      ]
    }, oe = [
      l.APOS_STRING_MODE,
      l.QUOTE_STRING_MODE,
      z,
      K,
      ce,
      S,
      l.REGEXP_MODE
    ];
    w.contains = oe.concat({
      // we need to pair up {} inside our subst to prevent
      // it from ending too early by matching another }
      begin: /\{/,
      end: /\}/,
      keywords: E,
      contains: [
        "self"
      ].concat(oe)
    });
    const re = [].concat(X, w.contains), te = re.concat([
      // eat recursive parens in sub expressions
      {
        begin: /\(/,
        end: /\)/,
        keywords: E,
        contains: ["self"].concat(re)
      }
    ]), ae = {
      className: "params",
      begin: /\(/,
      end: /\)/,
      excludeBegin: !0,
      excludeEnd: !0,
      keywords: E,
      contains: te
    };
    return {
      name: "Javascript",
      aliases: ["js", "jsx", "mjs", "cjs"],
      keywords: E,
      // this will be extended by TypeScript
      exports: { PARAMS_CONTAINS: te },
      illegal: /#(?![$_A-z])/,
      contains: [
        l.SHEBANG({
          label: "shebang",
          binary: "node",
          relevance: 5
        }),
        {
          label: "use_strict",
          className: "meta",
          relevance: 10,
          begin: /^\s*['"]use (strict|asm)['"]/
        },
        l.APOS_STRING_MODE,
        l.QUOTE_STRING_MODE,
        z,
        K,
        ce,
        X,
        S,
        {
          // object attr container
          begin: N(
            /[{,\n]\s*/,
            // we need to look ahead to make sure that we actually have an
            // attribute coming up so we don't steal a comma from a potential
            // "value" container
            //
            // NOTE: this might not work how you think.  We don't actually always
            // enter this mode and stay.  Instead it might merely match `,
            // <comments up next>` and then immediately end after the , because it
            // fails to find any actual attrs. But this still does the job because
            // it prevents the value contain rule from grabbing this instead and
            // prevening this rule from firing when we actually DO have keys.
            U(N(
              // we also need to allow for multiple possible comments inbetween
              // the first key:value pairing
              /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,
              k + "\\s*:"
            ))
          ),
          relevance: 0,
          contains: [
            {
              className: "attr",
              begin: k + U("\\s*:"),
              relevance: 0
            }
          ]
        },
        {
          // "value" container
          begin: "(" + l.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
          keywords: "return throw case",
          contains: [
            X,
            l.REGEXP_MODE,
            {
              className: "function",
              // we have to count the parens to make sure we actually have the
              // correct bounding ( ) before the =>.  There could be any number of
              // sub-expressions inside also surrounded by parens.
              begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + l.UNDERSCORE_IDENT_RE + ")\\s*=>",
              returnBegin: !0,
              end: "\\s*=>",
              contains: [
                {
                  className: "params",
                  variants: [
                    {
                      begin: l.UNDERSCORE_IDENT_RE,
                      relevance: 0
                    },
                    {
                      className: null,
                      begin: /\(\s*\)/,
                      skip: !0
                    },
                    {
                      begin: /\(/,
                      end: /\)/,
                      excludeBegin: !0,
                      excludeEnd: !0,
                      keywords: E,
                      contains: te
                    }
                  ]
                }
              ]
            },
            {
              // could be a comma delimited list of params to a function call
              begin: /,/,
              relevance: 0
            },
            {
              className: "",
              begin: /\s/,
              end: /\s*/,
              skip: !0
            },
            {
              // JSX
              variants: [
                { begin: y.begin, end: y.end },
                {
                  begin: p.begin,
                  // we carefully check the opening tag to see if it truly
                  // is a tag and not a false positive
                  "on:begin": p.isTrulyOpeningTag,
                  end: p.end
                }
              ],
              subLanguage: "xml",
              contains: [
                {
                  begin: p.begin,
                  end: p.end,
                  skip: !0,
                  contains: ["self"]
                }
              ]
            }
          ],
          relevance: 0
        },
        {
          className: "function",
          beginKeywords: "function",
          end: /[{;]/,
          excludeEnd: !0,
          keywords: E,
          contains: [
            "self",
            l.inherit(l.TITLE_MODE, { begin: k }),
            ae
          ],
          illegal: /%/
        },
        {
          // prevent this from getting swallowed up by function
          // since they appear "function like"
          beginKeywords: "while if switch catch for"
        },
        {
          className: "function",
          // we have to count the parens to make sure we actually have the correct
          // bounding ( ).  There could be any number of sub-expressions inside
          // also surrounded by parens.
          begin: l.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
          // end parens
          returnBegin: !0,
          contains: [
            ae,
            l.inherit(l.TITLE_MODE, { begin: k })
          ]
        },
        // hack: prevents detection of keywords in some circumstances
        // .keyword()
        // $keyword = x
        {
          variants: [
            { begin: "\\." + k },
            { begin: "\\$" + k }
          ],
          relevance: 0
        },
        {
          // ES6 class
          className: "class",
          beginKeywords: "class",
          end: /[{;=]/,
          excludeEnd: !0,
          illegal: /[:"[\]]/,
          contains: [
            { beginKeywords: "extends" },
            l.UNDERSCORE_TITLE_MODE
          ]
        },
        {
          begin: /\b(?=constructor)/,
          end: /[{;]/,
          excludeEnd: !0,
          contains: [
            l.inherit(l.TITLE_MODE, { begin: k }),
            "self",
            ae
          ]
        },
        {
          begin: "(get|set)\\s+(?=" + k + "\\()",
          end: /\{/,
          keywords: "get set",
          contains: [
            l.inherit(l.TITLE_MODE, { begin: k }),
            { begin: /\(\)/ },
            // eat to avoid empty params
            ae
          ]
        },
        {
          begin: /\$[(.]/
          // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
        }
      ]
    };
  }
  function j(l) {
    const W = e, k = {
      beginKeywords: "namespace",
      end: /\{/,
      excludeEnd: !0
    }, y = {
      beginKeywords: "interface",
      end: /\{/,
      excludeEnd: !0,
      keywords: "interface extends"
    }, p = {
      className: "meta",
      relevance: 10,
      begin: /^\s*['"]use strict['"]/
    }, E = [
      "any",
      "void",
      "number",
      "boolean",
      "string",
      "object",
      "never",
      "enum"
    ], x = [
      "type",
      "namespace",
      "typedef",
      "interface",
      "public",
      "private",
      "protected",
      "implements",
      "declare",
      "abstract",
      "readonly"
    ], H = {
      $pattern: e,
      keyword: n.concat(x),
      literal: i,
      built_in: M.concat(E)
    }, C = {
      className: "meta",
      begin: "@" + W
    }, S = (K, ce, ee) => {
      const X = K.contains.findIndex((oe) => oe.label === ce);
      if (X === -1)
        throw new Error("can not find mode to replace");
      K.contains.splice(X, 1, ee);
    }, w = R(l);
    Object.assign(w.keywords, H), w.exports.PARAMS_CONTAINS.push(C), w.contains = w.contains.concat([
      C,
      k,
      y
    ]), S(w, "shebang", l.SHEBANG()), S(w, "use_strict", p);
    const z = w.contains.find((K) => K.className === "function");
    return z.relevance = 0, Object.assign(w, {
      name: "TypeScript",
      aliases: ["ts", "tsx"]
    }), w;
  }
  return Je = j, Je;
}
var Qn = Jn();
const Rt = /* @__PURE__ */ vt(Qn);
var At = qn(Rt, {});
At.registerLanguage = Rt.registerLanguage;
var ec = Zn();
const tc = /* @__PURE__ */ vt(ec), nc = {
  hljs: {
    display: "block",
    overflowX: "auto",
    padding: "0.5em",
    color: "#000",
    background: "#f8f8ff"
  },
  "hljs-comment": {
    color: "#408080",
    fontStyle: "italic"
  },
  "hljs-quote": {
    color: "#408080",
    fontStyle: "italic"
  },
  "hljs-keyword": {
    color: "#954121"
  },
  "hljs-selector-tag": {
    color: "#954121"
  },
  "hljs-literal": {
    color: "#954121"
  },
  "hljs-subst": {
    color: "#954121"
  },
  "hljs-number": {
    color: "#40a070"
  },
  "hljs-string": {
    color: "#219161"
  },
  "hljs-doctag": {
    color: "#219161"
  },
  "hljs-selector-id": {
    color: "#19469d"
  },
  "hljs-selector-class": {
    color: "#19469d"
  },
  "hljs-section": {
    color: "#19469d"
  },
  "hljs-type": {
    color: "#19469d"
  },
  "hljs-params": {
    color: "#00f"
  },
  "hljs-title": {
    color: "#458",
    fontWeight: "bold"
  },
  "hljs-tag": {
    color: "#000080",
    fontWeight: "normal"
  },
  "hljs-name": {
    color: "#000080",
    fontWeight: "normal"
  },
  "hljs-attribute": {
    color: "#000080",
    fontWeight: "normal"
  },
  "hljs-variable": {
    color: "#008080"
  },
  "hljs-template-variable": {
    color: "#008080"
  },
  "hljs-regexp": {
    color: "#b68"
  },
  "hljs-link": {
    color: "#b68"
  },
  "hljs-symbol": {
    color: "#990073"
  },
  "hljs-bullet": {
    color: "#990073"
  },
  "hljs-built_in": {
    color: "#0086b3"
  },
  "hljs-builtin-name": {
    color: "#0086b3"
  },
  "hljs-meta": {
    color: "#999",
    fontWeight: "bold"
  },
  "hljs-deletion": {
    background: "#fdd"
  },
  "hljs-addition": {
    background: "#dfd"
  },
  "hljs-emphasis": {
    fontStyle: "italic"
  },
  "hljs-strong": {
    fontWeight: "bold"
  }
}, cc = {
  hljs: {
    display: "block",
    overflowX: "auto",
    padding: "0.5em",
    background: "#2b2b2b",
    color: "#bababa"
  },
  "hljs-strong": {
    color: "#a8a8a2"
  },
  "hljs-emphasis": {
    color: "#a8a8a2",
    fontStyle: "italic"
  },
  "hljs-bullet": {
    color: "#6896ba"
  },
  "hljs-quote": {
    color: "#6896ba"
  },
  "hljs-link": {
    color: "#6896ba"
  },
  "hljs-number": {
    color: "#6896ba"
  },
  "hljs-regexp": {
    color: "#6896ba"
  },
  "hljs-literal": {
    color: "#6896ba"
  },
  "hljs-code": {
    color: "#a6e22e"
  },
  "hljs-selector-class": {
    color: "#a6e22e"
  },
  "hljs-keyword": {
    color: "#cb7832"
  },
  "hljs-selector-tag": {
    color: "#cb7832"
  },
  "hljs-section": {
    color: "#cb7832"
  },
  "hljs-attribute": {
    color: "#cb7832"
  },
  "hljs-name": {
    color: "#cb7832"
  },
  "hljs-variable": {
    color: "#cb7832"
  },
  "hljs-params": {
    color: "#b9b9b9"
  },
  "hljs-string": {
    color: "#6a8759"
  },
  "hljs-subst": {
    color: "#e0c46c"
  },
  "hljs-type": {
    color: "#e0c46c"
  },
  "hljs-built_in": {
    color: "#e0c46c"
  },
  "hljs-builtin-name": {
    color: "#e0c46c"
  },
  "hljs-symbol": {
    color: "#e0c46c"
  },
  "hljs-selector-id": {
    color: "#e0c46c"
  },
  "hljs-selector-attr": {
    color: "#e0c46c"
  },
  "hljs-selector-pseudo": {
    color: "#e0c46c"
  },
  "hljs-template-tag": {
    color: "#e0c46c"
  },
  "hljs-template-variable": {
    color: "#e0c46c"
  },
  "hljs-addition": {
    color: "#e0c46c"
  },
  "hljs-comment": {
    color: "#7f7f7f"
  },
  "hljs-deletion": {
    color: "#7f7f7f"
  },
  "hljs-meta": {
    color: "#7f7f7f"
  }
};
function fc({
  children: e,
  lang: n,
  style: i,
  showLineNumbers: o,
  showInlineLineNumbers: g,
  showCopy: u,
  className: I
}) {
  const [M, O] = vn(!1), { computedTheme: U } = bn(), N = Nn(() => {
    navigator.clipboard.writeText(e), O(!0), setTimeout(() => {
      O(!1);
    }, 3e3);
  }, [e]);
  return /* @__PURE__ */ pn("div", { className: mn("relative flex flex-col text-start", I), children: [
    !!u && /* @__PURE__ */ Pe(
      Sn,
      {
        onClick: N,
        variant: "ghost",
        size: "icon",
        className: "absolute right-2 top-2 size-5",
        children: M ? /* @__PURE__ */ Pe(yn, { className: "size-4 scale-100 transition-all" }) : /* @__PURE__ */ Pe(En, { className: "size-4 scale-100 transition-all" })
      }
    ),
    /* @__PURE__ */ Pe(
      At,
      {
        language: n ?? tc,
        style: i ?? U === "dark" ? cc : nc,
        showLineNumbers: o,
        showInlineLineNumbers: g,
        children: e
      }
    )
  ] });
}
export {
  fc as CodeBlock
};
//# sourceMappingURL=code-block.js.map
